export default "__VITE_ASSET__c041b5da__"